import React from 'react'
import Footer from '../Components/Outlets/Footer'
import Nav from '../Components/Outlets/Nav'
import about from '../Assets/about-gd-img.png'
import Cariculam from '../Assets/Cariculam.png'
import chair from '../Assets/founder.png'
import { Link } from 'react-router-dom'
const AboutPage = () => {
	return (
		<div>
			<Nav />
				<div class="about-page-main">
					<div className="path-menu">
						<div className="container-main">
							<h2 class="page-heading-name mb-0">About Us</h2>
						</div>
					</div>
					<div className="about-section-pg">
					<div className="main-padding">
						<div className="container-main">
							<div className="main">
								<div className="row">
									<div className="col-lg-6">
										<div className="chairman-message-dv">
											<h2 className='chairman-text'>Chairman Message</h2>
											<p className='text-about-sub top'>We aim to facilitate a fertile ground for the overall growth of the next generation with their souls engraved in spiritual values and their skills ranging from coding to critical thinking chiselled to meet the unseen future of science and technology.</p>
											<p className='text-about-sub'>Éloria stands as the fulfilment of the dream of a skilled young generation who can contribute to national resources and boost the moral development. This destination for incubating the youth by fostering magnanimity in them will also take them to the summit of science and conscience.</p>
										</div>
									</div>
									<div className="col-lg-6">
										<div className="chairman-message-dv">
											<img src={chair} className='chair-man' alt="" />
										</div>
									</div>
								</div>
								<div className="second-row">
									<div className="row">
										<div className="col-lg-6">
											<div className="chairman-message-dv">
												<img src={about} className='about-curved' alt="" />
											</div>
										</div>
										<div className="col-lg-6">
											<div className="chairman-message-dv">
												<h2 className='chairman-text'>Vision</h2>
												<p className='text-about-sub'>We aim to facilitate a fertile ground for the overall growth of the next generation with their souls engraved in spiritual values and their skills ranging from coding to critical thinking chiselled to meet the unseen future of science and technology. Éloria stands as the fulfilment of the dream of a skilled young generation who can contribute to national resources and boost the moral development. This destination for incubating the youth by fostering magnanimity in them will also take them to the summit of science and conscience.</p>
												<h2 className='chairman-text'>Mission</h2>
												<p className='text-about-sub'>We aim to facilitate a fertile ground for the overall growth of the next generation with their souls engraved in spiritual values and their skills ranging from coding to critical thinking chiselled to meet the unseen future of science and technology.</p>
											</div>
										</div>
										<div className="col-lg-12">
											<div className="chairman-message-dv">
												<h2 className='chairman-text'>Our Carriculum</h2>
												<p className='text-about-sub'>Psychologically administered pedagogy that can boost memorizing skills along with inculcation analytic vigor.</p>
												<div className="btns-dvs">
													<Link className='btn btn-curic'>Recitation Science</Link>
													<Link className='btn btn-curic'>Tajweed</Link>
													<Link className='btn btn-curic'>Memorisation</Link>
													<Link className='btn btn-curic'>School education (CBSE/State) Islamic studies													</Link>
													<Link className='btn btn-curic'>Languages (English & Arabic)													</Link>
												</div>
											</div>
										</div>
										<div className="col-lg-12">
											<div className="chairman-message-dv">
												<img src={Cariculam} className='about-cariculam' alt="" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	)
}
export default AboutPage;